export default class PaymentSelector {
    constructor($el){
        this.$root = $el;
        this.items = [];
        this.activeIndex = null;

        this.setup();
    }

    setup(){
        var $options = this.$root.find('.payment-selector-options > li');
        var $holders = this.$root.find('.payment-selector-holders > li');

        var selectedIndex = 0;
        var self = this;
        $options.each(function(index){
            var $option = $(this);
            var $radio = $option.find('input[type="radio"]');
            var $holder = $($holders[index]).hide();

            self.items.push({
                $option: $option,
                $radio: $radio,
                $holder: $holder
            });

            if($radio.prop('checked'))
                selectedIndex = index;

            $option.find('a').click(function(){
                self.select(index);
            });
        });

        this.select(selectedIndex);
    }

    select(index){
        if(this.activeIndex !== null){
            var item = this.items[this.activeIndex];
            item.$option.removeClass('active');
            item.$holder.hide();
        }

        this.activeIndex = index;
        var item = this.items[this.activeIndex];
        item.$radio.prop('checked', true);
        item.$option.addClass('active');
        item.$holder.show();
    }
}
